
import { RevButton, RevIllustration } from '@backmarket/design-system'

import translations from './NoOffer.translations'

export default {
  components: {
    RevButton,
    RevIllustration,
  },
  props: {
    closeWording: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
  mounted() {
    this.$emit('tracking', { type: 'noOffer' })
  },
  methods: {
    handleClick() {
      this.$emit('completed', { to: 'close' })
    },
  },
}
